









































































import { Object } from 'lodash'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { IPatient } from '@/store/modules/views/patient/states'
import { IBank } from '@/store/modules/components/states'
import { ICenter } from '@/store/modules/views/center/states'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

@Component
export default class Dashboard extends VueExtendedBaseComponent {
  private centerSelected = 'all'
  private data = {
    caregiver: 0,
    patient: 0,
    staff: 0,
    job: 0,
    jobWaiting: 0,
    jobDoing: 0,
    jobComplete: 0,
    payment: 0,
    paymentSuccess: 0,
    paymentWait: 0,
    paymentFail: 0,
    income: 0,
    incomeCenter: 0,
    incomeCaregiver: 0,
  }

  private clearTimeoutValue: NodeJS.Timeout = setTimeout(() => undefined, 100)

  get headers(): Array<{ text: string; value: string }> {
    return this.headerLists
  }

  get items() {
    return _.concat<{_id: string, name: string}>([{_id: 'all', name: 'ทั้งหมด'}], this.centerItemLists)
  }

  get paginationLists() {
    return this.pagination
  }

  @Getter('center/centerById')
  private centerById!: {[centerId: string]: ICenter}

  @Getter('center/itemLists')
  private centerItemLists!: ICenter[]

  @Getter('components/banks')
  private banks: IBank[]

  @Action('components/updateTitlePage')
  private updateTitlePage!: (title: string) => void

  @Action('payment/getPaymentList')
  private getPaymentList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Getter('payment/headerLists')
  private headerLists!: Array<{ text: string; value: string }>

  @Getter('payment/itemLists')
  private itemLists!: () => void

  @Getter('payment/pagination')
  private pagination!: () => void

  private findBank(bank: string) {
    const result = _.find(this.banks, (b) => b.name === bank)
    return result ? result.text : bank
  }

  private async handleChangeCenter() {
    await HttpRequestServiceWithToken.getByLevel(
      process.env.VUE_APP_API_URL + '/v1',
      `dashboard/${this.centerSelected}`, {},
      (res) => {
        this.data = res
      },
    )
  }

  private created() {
    this.centerSelected = this.level.id
    this.updateTitlePage('ข้อมูลสรุป')
    this.handleChangeCenter()
    // Promise.all([
    //   this.get
    // ])
  }
}
